import markerImg from '../../img/custom-map-marker.svg';
import markerImgActive from '../../img/custom-map-marker-active.svg';

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

export default class Recherche extends HTMLDivElement {

    constructor() {
        super();
        this.typeOffreSelect = this.querySelector('#typeOffreSelect');
        this.publicViseSelect = this.querySelector('#publicViseSelect');
        this.secteurSelect = this.querySelector('#secteurSelect');
        this.handicapSelect = this.querySelector('#handicapSelect');
        this.ageSelect = this.querySelector('#ageSelect');

        // Map related properties
        this.toggleBtn = null;
        this.icon = null;
        this.iconActive = null;
        this.map = null;
        this.markers = [];
        this.markerClusterGroup = null;
        this.markersDatas = [];
        this.isMapView = false;
        this.currentFilter = -1;
        this.currentSelectedIndex = -1;
        this.isSpiderfied = false;
    }

    // Getters dynamiques - toujours à jour après AJAX
    get mapContainer() {
        return this.querySelector('#offre-event-map');
    }

    get listContainer() {
        return this.querySelector('#offre-event-list');
    }

    get listItems() {
        return this.querySelectorAll('#offre-event-map .result-list-item');
    }

    get detailItems() {
        return this.querySelectorAll('#offre-event-map .result-details');
    }

    connectedCallback() {
        // Délégation d'événements sur le composant - capte tous les clics même après AJAX
        this.addEventListener("click", (e) => {
            // Gestion des filtres
            const filterLink = e.target.closest('.js-filter-offre');
            if (filterLink) {
                // Empêcher le scroll vers le haut uniquement si le lien est un ancre "#"
                if (filterLink.getAttribute('href') === '#') {
                    e.preventDefault();
                }
                this.handleFilterClick(filterLink);
                return;
            }

            // Gestion du clic sur les items de la liste carte
            const listItem = e.target.closest('.result-list-item');
            if (listItem && !e.target.closest('a')) {
                const index = parseInt(listItem.dataset.index);
                this.setCurrentItem(index);
                return;
            }

            // Gestion du bouton toggle (maintenant dans le composant via délégation)
            const toggleLink = e.target.closest('#btn-toggle-map-view a, #btn-toggle-map-view');
            if (toggleLink) {
                e.preventDefault();
                this.toggleView();
                return;
            }
        });

        if (this.typeOffreSelect) {
            if (this.publicViseSelect) {
                this.callDataSelect(this.publicViseSelect)
            }
            this.callDataSelect(this.typeOffreSelect)
            this.callDataSelect(this.secteurSelect)
            this.callDataSelect(this.handicapSelect)
            this.callDataSelect(this.ageSelect)
        }

        // Initialize map functionality
        this.initMapFeatures();
    }

    handleFilterClick(filterLink) {
        const typeOffre2Selected = filterLink.dataset.id;
        const href = filterLink.getAttribute('href');

        // Si le lien pointe vers une vraie URL (page événements), laisser la navigation serveur se faire
        if (href && href !== '#') {
            this.currentFilter = parseInt(typeOffre2Selected);
            if (this.map && this.markerClusterGroup) {
                this.addMarkers();
                this.filterListItems();
            }
            return;
        }

        // Sinon (page recherche, href="#") : filtrage DOM côté client uniquement
        this.querySelectorAll('.js-filter-offre').forEach(link => link.classList.remove('active'));
        filterLink.classList.add('active');

        const listContainer = this.listContainer;
        if (listContainer) {
            listContainer.querySelectorAll('.card-event').forEach(card => {
                card.parentElement.style.display = '';
            });

            if (typeOffre2Selected != -1) {
                listContainer.querySelectorAll('.card-event').forEach(card => {
                    card.parentElement.style.display = 'none';
                });
                listContainer.querySelectorAll('.tag[data-offre2id="' + typeOffre2Selected + '"]').forEach(tag => {
                    const cardEvent = tag.closest('.card-event');
                    if (cardEvent) {
                        cardEvent.parentElement.style.display = '';
                    }
                });
            }
        }

        this.currentFilter = parseInt(typeOffre2Selected);
        if (this.map && this.markerClusterGroup) {
            this.addMarkers();
            this.filterListItems();
        }
    }

    refreshMapData() {
        const jsonDataElement = this.querySelector('#jsonOffresEvents');
        if (jsonDataElement && jsonDataElement.dataset.json) {
            try {
                this.markersDatas = JSON.parse(jsonDataElement.dataset.json);
            } catch (e) {
                console.error('Erreur parsing JSON offres/events:', e);
                this.markersDatas = [];
            }
        } else {
            this.markersDatas = [];
        }
    }

    initMapFeatures() {
        this.refreshMapData();

        // Le bouton est DANS le composant (dans _Search.cshtml)
        this.toggleBtn = this.querySelector('#btn-toggle-map-view');

        // Check if we're in map view from URL
        const urlParams = new URLSearchParams(window.location.search);
        this.isMapView = urlParams.get('view') === 'map';

        // Initialize display
        this.updateViewMode();

        // Initialize map if in map view
        if (this.isMapView && this.mapContainer) {
            this.initMap();
        }
    }

    setCurrentItem(index) {
        this.currentSelectedIndex = index;

        // Update active state on list items (utilise les getters)
        this.listItems.forEach(item => {
            item.classList.toggle('active', parseInt(item.dataset.index) === index);
        });

        // Update active state on detail items
        this.detailItems.forEach(detail => {
            detail.classList.toggle('active', parseInt(detail.dataset.index) === index);
        });

        // Find the corresponding marker data
        const itemData = this.markersDatas.find(d => d.index === index);
        
        if (itemData && this.map) {
            this.markers.forEach(marker => {
                if (marker.options.data && marker.options.data.index === index) {
                    marker.setIcon(this.iconActive);
                    this.map.setView(marker.getLatLng(), 14, {
                        animate: true,
                        duration: 0.5
                    });
                    marker.openPopup();
                } else {
                    marker.setIcon(this.icon);
                }
            });
        }
    }

    filterListItems() {
        this.listItems.forEach(item => {
            const itemTypeOffre2Id = parseInt(item.dataset.offre2id);
            if (this.currentFilter === -1 || itemTypeOffre2Id === this.currentFilter) {
                item.style.display = '';
            } else {
                item.style.display = 'none';
            }
        });

        // Fermer le panneau de détail si l'élément sélectionné est filtré
        if (this.currentSelectedIndex !== -1) {
            const selectedData = this.markersDatas.find(d => d.index === this.currentSelectedIndex);
            if (selectedData && this.currentFilter !== -1 && selectedData.typeOffre2Id !== this.currentFilter) {
                this.closeDetailPanel();
            }
        }
    }

    toggleView() {
        this.isMapView = !this.isMapView;

        // Update URL
        const url = new URL(window.location);
        if (this.isMapView) {
            url.searchParams.set('view', 'map');
        } else {
            url.searchParams.delete('view');
        }
        window.history.pushState({}, '', url);

        this.updateViewMode();

        // Rafraîchir les données et (re)créer la carte si besoin
        if (this.isMapView && this.mapContainer) {
            this.refreshMapData();
            
            // Supprimer l'ancienne carte si elle existe
            if (this.map) {
                this.map.remove();
                this.map = null;
                this.markerClusterGroup = null;
                this.markers = [];
            }
            this.initMap();
        }
    }

    updateViewMode() {
        const listContainer = this.listContainer;
        const mapContainer = this.mapContainer;
        
        // Récupérer le bouton toggle (peut avoir changé après AJAX)
        const toggleBtn = this.querySelector('#btn-toggle-map-view');

        if (listContainer) {
            listContainer.style.display = this.isMapView ? 'none' : '';
        }
        if (mapContainer) {
            mapContainer.style.display = this.isMapView ? '' : 'none';
        }

        // Update button text and icon
        if (toggleBtn) {
            const lien = toggleBtn.querySelector('a');
            if (lien) {
                const icon = lien.querySelector('i');
                const text = lien.querySelector('span');
                if (this.isMapView) {
                    if (icon) icon.className = 'ri-list-unordered';
                    if (text) text.textContent = 'Retour à la liste';
                } else {
                    if (icon) icon.className = 'ri-map-2-line';
                    if (text) text.textContent = 'Voir sur la carte';
                }
            }
        }
    }

    initMap() {
        const mapContainer = this.mapContainer;
        if (!mapContainer) return;

        const mapElement = mapContainer.querySelector('.map');
        if (!mapElement) return;

        // Center on Finistère by default
        this.map = L.map(mapElement, {
            zoomControl: false
        }).setView([48.3, -4.1], 9);

        L.control.zoom({
            position: 'topright'
        }).addTo(this.map);

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            // OSM bloque les tuiles demandées sans en-tête Referer ; le site envoie
            // "Referrer-Policy: no-referrer" (Program.cs), on le surcharge pour les tuiles.
            referrerPolicy: 'strict-origin-when-cross-origin'
        }).addTo(this.map);

        // Custom icons
        this.icon = L.icon({
            iconUrl: markerImg,
            iconSize: [30, 45],
            iconAnchor: [15, 45],
            popupAnchor: [0, -45]
        });

        this.iconActive = L.icon({
            iconUrl: markerImgActive,
            iconSize: [30, 45],
            iconAnchor: [15, 45],
            popupAnchor: [0, -45]
        });

        // Cluster group
        this.markerClusterGroup = L.markerClusterGroup({
            showCoverageOnHover: false,
            maxClusterRadius: 50,
            spiderfyOnMaxZoom: true,
            disableClusteringAtZoom: 16,
            zoomToBoundsOnClick: false,
            spiderfyDistanceMultiplier: 1.5,
            iconCreateFunction: (cluster) => {
                const count = cluster.getChildCount();
                return L.divIcon({
                    html: `<div class="cluster-icon"><span>${count}</span></div>`,
                    className: 'custom-cluster-icon',
                    iconSize: [40, 40]
                });
            }
        });

        this.addMarkers();
        this.map.addLayer(this.markerClusterGroup);

        // Adjust view to all markers
        if (this.markersDatas.length > 0) {
            const bounds = this.calculateMarkersBounds();
            if (bounds.isValid()) {
                this.map.fitBounds(bounds, { padding: [50, 50] });
            }
        }

        // Event listener for cluster click
        this.markerClusterGroup.on('clusterclick', (e) => {
            const cluster = e.layer;
            const bottomCluster = cluster._zoom === this.map.getMaxZoom();
            
            if (bottomCluster || cluster.getAllChildMarkers().length <= 10) {
                cluster.spiderfy();
            } else {
                cluster.zoomToBounds({ padding: [50, 50] });
            }
        });

        this.markerClusterGroup.on('spiderfied', () => {
            this.isSpiderfied = true;
        });

        this.markerClusterGroup.on('unspiderfied', () => {
            this.isSpiderfied = false;
        });

        this.map.on('click', () => {
            if (!this.isSpiderfied) {
                this.closeDetailPanel();
            }
        });
    }

    addMarkers() {
        this.markers = [];
        this.markerClusterGroup.clearLayers();

        const filteredData = this.currentFilter === -1
            ? this.markersDatas
            : this.markersDatas.filter(d => d.typeOffre2Id === this.currentFilter);

        filteredData.forEach((data) => {
            if (data.lat && data.lng) {
                const marker = L.marker([data.lat, data.lng], {
                    icon: this.icon,
                    data: data
                });

                marker.on('click', () => {
                    this.setCurrentItem(data.index);
                });

                marker.bindPopup(this.createPopupContent(data), {
                    closeButton: false,
                    offset: [0, -10]
                });

                marker.on('mouseover', function () {
                    this.openPopup();
                });
                marker.on('mouseout', function () {
                    this.closePopup();
                });

                this.markerClusterGroup.addLayer(marker);
                this.markers.push(marker);
            }
        });
    }

    createPopupContent(data) {
        return `
            <div class="map-popup">
                <strong>${data.titre}</strong>
                <small>${data.ville || ''}</small>
            </div>
        `;
    }

    closeDetailPanel() {
        this.detailItems.forEach(detail => {
            detail.classList.remove('active');
        });

        this.markers.forEach(marker => {
            marker.setIcon(this.icon);
        });

        this.listItems.forEach(item => {
            item.classList.remove('active');
        });

        this.currentSelectedIndex = -1;
    }

    calculateMarkersBounds() {
        const bounds = L.latLngBounds();

        const filteredData = this.currentFilter === -1
            ? this.markersDatas
            : this.markersDatas.filter(d => d.typeOffre2Id === this.currentFilter);

        filteredData.forEach(data => {
            if (data.lat && data.lng) {
                bounds.extend([data.lat, data.lng]);
            }
        });

        return bounds;
    }

    callDataSelect(idSelect) {
        $.ajax({
            url: $(idSelect).data().url,
            type: 'GET',
            dataType: 'json',
            success: function (data) {
                var select = $(idSelect);
                $.each(data, function (index, item) {
                    select.append($('<option>', {
                        value: item.Value,
                        text: item.Text
                    }));
                });
            },
            error: function (error) {
            }
        });
    }
}